import { createSelector } from 'reselect';
export const allTrueSelector = selectors => {
  return createSelector(state => selectors.map(selector => selector(state)), results => results.every(Boolean));
};
export const anyTrueSelector = selectors => {
  return createSelector(state => selectors.map(selector => selector(state)), results => results.some(Boolean));
};